export default [
  {
    key: 'actions',
    visible: true
  },
  {
    key: 'community',
    sortable: true,
    visible: true
  },
  {
    key: 'date',
    sortable: true,
    visible: true
  }
];